import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "transparent",
  stroke: "#000",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "inherit",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9.577 17.241c.273.1.573.1.847 0a10.67 10.67 0 0 1 6.797-.35 1.254 1.254 0 0 0 1.567-1.218V4.475a1.255 1.255 0 0 0-.875-1.194 10.84 10.84 0 0 0-7.489.156 1.26 1.26 0 0 1-.847 0 10.84 10.84 0 0 0-7.49-.156 1.255 1.255 0 0 0-.876 1.194v11.198a1.255 1.255 0 0 0 1.567 1.218 10.67 10.67 0 0 1 6.799.35M10 3.501v13.815"
    }, null, -1)
  ])))
}
export default { render: render }